// @ts-expect-error - metroid-components types not exported for bundler resolution
import type { MetroidResponse } from '@zillow/metroid-components/dist/types/lib/types';

export const METROID_CONFIG_URL = {
  PROD: 'https://metroid-billing-api-gateway.prod.zgk-partner.zillowapi.com/api/alicorn/client',
  NON_PROD: 'https://metroid-billing-api-gateway-client.stage.kong-nonprod.zg-int.net/api/alicorn/client',
  NON_PROD_UAT: 'https://metroid-billing-api-gateway-uat-client.stage.kong-nonprod.zg-int.net/api/alicorn/client',
};

export const METROID_HPP_CONFIG_ID = {
  PROD: 'CC:Zillow:Rentals Consumers',
  QA: 'CC:Zillow:Rentals Consumers:qa',
  UAT: 'CC:Zillow:Rentals Consumers:uat',
  RA1: 'CC:Zillow:Rentals Consumers:ra1',
  RA2: 'CC:Zillow:Rentals Consumers:ra2',
  LOCAL: 'CC:Zillow:Rentals Consumers:Localhost',
};

export const ACTIONABLE_METROID_ERROR_CODES = {
  ZEUI: 'ZE-UI',
  INVALID_SESSION_TOKEN: 'INV-ACS',
  EXPIRED_SESSION_TOKEN: 'SESS-TO',
};

export const METROID_ERROR_REGEX = {
  ZIP: /zip/i,
  EXPIRATION: /expiration/i,
  DOWNSTREAM: /Downstream/i,
  ATTEMPTS_EXCEEDED: /Attempt_Exceed_Limitation/i,
  SUBMIT_TOO_QUICK: /Submit_Too_Quick/i,
};

export const METROID_ERROR_MESSAGES = {
  GENERIC: 'Transaction couldn’t be completed. Check your information and try again.',
  ZIP: 'Enter a valid ZIP code',
  EXPIRATION: 'Enter a future expiration date',
  SUBMIT_TOO_QUICK: 'Transaction couldn’t be completed after too many attempts. Wait and try again.',
};

export function getMetroidErrorMessage(e: MetroidResponse<null>) {
  const { code_details } = e;
  let message = METROID_ERROR_MESSAGES.GENERIC;
  if (code_details && METROID_ERROR_REGEX.ZIP.test(code_details)) {
    message = METROID_ERROR_MESSAGES.ZIP;
  } else if (code_details && METROID_ERROR_REGEX.EXPIRATION.test(code_details)) {
    message = METROID_ERROR_MESSAGES.EXPIRATION;
  } else if (code_details && METROID_ERROR_REGEX.SUBMIT_TOO_QUICK.test(code_details)) {
    message = METROID_ERROR_MESSAGES.SUBMIT_TOO_QUICK;
  }
  return message;
}
